import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import IntlCurrencyInput from "react-intl-currency-input"

import { isNullOrEmpty } from "../../utils/valid-value"; //
import { notificacaoAlert } from "../../utils/notication";


import {
    getVisibilidadeConfiguracao,
    postConfiguracaoCobertura,
    postConfiguracaoDocumentos,
    postConfiguracaoRelogio,
    postConfiguracaoValores,
    postConfiguracaoVincularRegulacao,
    postConfiguracaoAcionarPericia,
    postConfiguracaoAlterarLider,
    postConfiguracaoAlterarSubLider,
    postConfiguracaoAlterarStatusOcorrencia
} from '../../services/visibilidadeConfiguracao';

import { DynamicTextareaOnChange } from "../../components/DynamicTextarea";
import { DynamicInput, DynamicInput2 } from "../../components/DynamicInput";
import { DynamicSelect } from "../../components/DynamicSelect";
import { ToggleSwitchFilters } from "../ToggleSwitchFilters";
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledVisibilidadeModal } from "../../styled-components/StyledVisibilidadeModal";
import { StldInput } from '../../styled-components/StyledInput.style';
import { set } from "react-hook-form";



export const ModalVisibilidadeConfiguracoes = ({
    processo,
    coberturaStatusType,
    statusDocumentacao,
    peritosList,
    isOpen,
    setIsOpen,
    aoSalvar
}) => {

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '60%',
            maxWidth: '80%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const searchStyling = {
        height: "36px",
        border: "1px solid #dfe1e5",
        borderRadius: "4px",
        backgroundColor: "white",
        boxShadow: "none",
        hoverBackgroundColor: "#eee",
        color: "#212121",
        fontSize: "16px",
        fontFamily: "inherit",
        iconColor: "grey",
        lineColor: "rgb(232, 234, 237)",
        placeholderColor: "grey",
        clearIconMargin: "3px 14px 0 0",
        searchIconMargin: "0 0 0 16px",
        zIndex: 1000,
    };

    const currencyConfig = {
        locale: "pt-BR",
        formats: {
            number: {
                BRL: {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                },
            },
        },
    };


    const [isVisualizarAcoesConfiguracao, setIsVisualizarAcoesConfiguracao] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const [visibilidadeSettings, setVisibilidadeSettings] = useState(null);

    //#region REVER TUDO ENTRE ESSA MENSAGEM
    const [isSubLiderChecked, setIsSubLiderChecked] = useState(false);
    const toggleSubLiderConfig = { name: 'toggleSubLiderCheck', label: '', id: 'toggleSubLiderCheck', status: isSubLiderChecked, checked: isSubLiderChecked };
    const getToggleSubLiderCheck = (status) => {
        setIsSubLiderChecked(status => !status);

        acaoAlterarSubLider();
    };

    // Sub Líder
    const [peritosType, setPeritosType] = useState([]);
    var [subLider, setSubLider] = useState(null);
    const getSubLider = (currentValue, value) => {
        if (!value) {
            setSubLider(null);
            return;
        }

        var subLiderResult = peritosType.filter(function (o) {
            return o.key == value;
        });
        subLider = subLiderResult[0].value;
        setSubLider(subLider);

        acaoAlterarSubLider();

    };

    const getVincularRegulacao = (currentValue, value) => {
        if (!value) {
            setVincularRegulacao(null);
            setIdVincularRegulacao(null);
            return;
        }

        var vincularRegulacaoResult = itemsRegulacaoAutocomplete.filter(function (o) {
            return o.key == value;
        });
        vincularRegulacao = vincularRegulacaoResult[0].value;
        idVincularRegulacao = vincularRegulacaoResult[0].key;
        setVincularRegulacao(vincularRegulacao);
        setIdVincularRegulacao(idVincularRegulacao);
    };

    var [motivosOcorrenciaType, setMotivosOcorrenciaType] = useState(null);
    var [motivoOcorrenciaSelect, setMotivoOcorrenciaSelect] = useState(null);
    const getMotivoOcorrenciaSelect = (currentValue, value) => {
        if (!value) {
            setMotivoOcorrenciaSelect(null);
            return;
        }

        var subLiderResult = motivosOcorrenciaType.filter(function (o) {
            return o.key == value;
        });
        subLider = subLiderResult[0].value;
        setMotivoOcorrenciaSelect(subLider);
    };


    

    


    const ConfirmarAcao = async (text) => {
        return Swal.fire({
            text: text ?? "Deseja confirmar esta ação?",
            allowOutsideClick: false,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        });
    };

    // Inicio das ações de configuração
    
    const acaoVincularRegulacao = async () => {
        ConfirmarAcao("Deseja vincular regulação?").then((result) => {
            if (result.isConfirmed) {
                postConfiguracaoVincularRegulacao({
                    idProcesso: processo?.idProcesso,
                    idRegulacao: idVincularRegulacao
                }).then((response) => {
                    notificacaoAlert("Sucesso", "Regulação vinculada com sucesso.", "success", 2000);
                });
            }
        });
    }


    const acaoAcionarPericia = async () => {
        ConfirmarAcao("Deseja acionar perícia?").then((result) => {
            if (result.isConfirmed) {
                postConfiguracaoAcionarPericia({
                    idProcesso: processo?.idProcesso,
                    idEmpresaPericia: periciaAdd
                }).then((response) => {
                    notificacaoAlert("Sucesso", "Perícia acionada com sucesso.", "success", 2000);
                });
            }
        });
    }

    const acaoAlterarSubLider = async () => {
        if (isSubLiderChecked && isNullOrEmpty(subLider)) {
            notificacaoAlert("Atenção", "O campo 'Sub-Líder' é obrigatório quando a opção está ativada.", "warning", 5000);
            return;
        }


        ConfirmarAcao("Deseja alterar o sub-líder?").then((result) => {
            if (result.isConfirmed) {
                postConfiguracaoAlterarSubLider({
                    idProcesso: processo?.idProcesso,
                    ativarSubLider: isSubLiderChecked,
                    idSubLider: subLider?.id
                }).then((response) => {
                    notificacaoAlert("Sucesso", "Sub-líder alterado com sucesso.", "success", 2000);
                });
            }
        });
    }
    

    //#endregion REVER TUDO ENTRE ESSA MENSAGEM

    //#region CARREGAMENTO DE CONFIGURAÇÕES
    const onAfterOpen = () => { };
    const closeModal = () => {
        setisLoading(false);
        setIsOpen(false);
        setItemsRegulacaoAutocomplete([]);

        setCoberturaSelected(null);
        setCoberturaSelectedId(null);
        setValorPleiteado(0);
        setValorEstimado(0);
        setValorApurado(0);
        setLiderSelected(null);
        setLiderSelectedId(null);
        setCoberturaSelectedSave(false);
        setMotivoSelected(null);
        setMotivoSelectedId(null);
        setStatusOcorrenciaDescricao(null);
        setEncerrarReabrirSave(false);

        if (aoSalvar) { aoSalvar(processo.idProcesso, processo.idTipoServico); }
    }

    const getVisibilidadeConfiguracaoAPI = async () => {
        const visibilidadeSettings = await getVisibilidadeConfiguracao(processo?.idProcesso, processo?.idTipoServico);

        if (visibilidadeSettings) {
            setVisibilidadeSettings(visibilidadeSettings);
            setIsVisualizarAcoesConfiguracao(visibilidadeSettings);
            setMotivosOcorrenciaType(visibilidadeSettings?.motivosStatusOcorrencia);

            // Configurações Processo Sinistro
            var coberturaSelectedLocal = coberturaStatusType.find(c => c.key === visibilidadeSettings?.processoSinistro?.cobertura?.statusCobertura)?.value ?? null;
            setCoberturaSelected(coberturaSelectedLocal);
            setCoberturaSelectedId(visibilidadeSettings?.processoSinistro?.cobertura?.statusCobertura ?? null);
            setDataCobertura(visibilidadeSettings?.processoSinistro?.cobertura?.dataCobertura ? new Date(visibilidadeSettings.processoSinistro.cobertura.dataCobertura) : null);
            setDataUltimoDocRegulacao(visibilidadeSettings?.processoSinistro?.documentos?.dataUltimoDocRegulacao ? new Date(visibilidadeSettings.processoSinistro.documentos.dataUltimoDocRegulacao) : null);
            setDataUltimoDocLiquidacao(visibilidadeSettings?.processoSinistro?.documentos?.dataUltimoDocLiquidacao ? new Date(visibilidadeSettings.processoSinistro.documentos.dataUltimoDocLiquidacao) : null);

            //Documentação
            var documentacaoRegulacaoSelectedLocal = statusDocumentacao.find(c => c.key === visibilidadeSettings?.processoSinistro?.documentos?.statusUltimoDocRegulacao)?.value ?? null;
            var documentacaoLiquidacaoSelectedLocal = statusDocumentacao.find(c => c.key === visibilidadeSettings?.processoSinistro?.documentos?.statusUltimoDocLiquidacao)?.value ?? null;
            setDocumentacaoRegulacaoSelected(documentacaoRegulacaoSelectedLocal);
            setDocumentacaoLiquidacaoSelected(documentacaoLiquidacaoSelectedLocal);

            //Configurações Valores
            setValorPleiteado(visibilidadeSettings?.valores?.pleiteado ?? null);
            setValorEstimado(visibilidadeSettings?.valores?.estimado ?? null);
            setValorApurado(visibilidadeSettings?.valores?.apurado ?? null);

            //Líder e Sub-líder
            setLiderSelected(visibilidadeSettings?.alterarLider?.nomeLider ?? null);
            setLiderSelectedId(visibilidadeSettings?.alterarLider?.idLider ?? null);

            //Reabrir/Encerrar Ocorrência
        }
    };   

    //#region PROCESSO SINISTRO
    //#region L--> Cobertura
    var [coberturaSelected, setCoberturaSelected] = useState(null);
    var [coberturaSelectedId, setCoberturaSelectedId] = useState(null);
    var [coberturaSelectedSave, setCoberturaSelectedSave] = useState(false);
    const getCoberturas = (currentValue, value) => {
        if (!value) {
            setCoberturaSelected(null);
            setCoberturaSelectedId(null);
            setCoberturaSelectedSave(false);
            return;
        }

        var coberturaResult = coberturaStatusType.filter(function (o) {
            return o.key == value;
        });
        coberturaSelected = coberturaResult[0].value;
        coberturaSelectedId = coberturaResult[0].key;
        setCoberturaSelected(coberturaSelected);
        setCoberturaSelectedId(coberturaSelectedId);
    }

    const [dataCobertura, setDataCobertura] = useState(null);
    const handleDateDataCoberturaChange = (date) => {
        setDataCobertura(date);
    }

    //L----> Cobertura Salvar
    const acaoAlterarCobertura = async () => {
        if (isNullOrEmpty(coberturaSelected)) {
            notificacaoAlert("Atenção", "O campo 'Status da Cobertura' é obrigatório.", "warning", 4000);
            return;
        }

        if (isNullOrEmpty(dataCobertura)) {
            notificacaoAlert("Atenção", "O campo 'Data da Cobertura' é obrigatório.", "warning", 4000);
            return;
        }

        ConfirmarAcao("Deseja alterar a informações de cobertura?").then((result) => {
            if (result.isConfirmed) {
                postConfiguracaoCobertura({
                    idProcesso: processo?.idProcesso,
                    idTipoServico: processo?.idTipoServico,
                    statusCobertura: coberturaSelectedId,
                    dataCobertura: dataCobertura
                }).then((response) => {
                    setCoberturaSelectedSave(true);
                    notificacaoAlert("Sucesso", "Informações de cobertura alteradas com sucesso.", "success", 2000);
                });
            }
        });
    }
    //#endregion
    //#region L--> Documentos
    var [documentacaoRegulacaoSelected, setDocumentacaoRegulacaoSelected] = useState(null);
    var [documentacaoRegulacaoSelectedId, setDocumentacaoRegulacaoSelectedId] = useState(null);
    var [documentacaoRegulacaoSelectedSave, setDocumentacaoRegulacaoSelectedSave] = useState(false);
    const [dataUltimoDocRegulacao, setDataUltimoDocRegulacao] = useState(null);    
    const getDocumentacaoRegulacao = (currentValue, value) => {
        if (!value) {
            setDocumentacaoRegulacaoSelected(null);
            setDocumentacaoRegulacaoSelectedId(null);
            setDocumentacaoRegulacaoSelectedSave(false);
            return;
        }

        var documentacaoRegulacaoResult = statusDocumentacao.filter(function (o) {
            return o.key == value;
        });
        documentacaoRegulacaoSelected = documentacaoRegulacaoResult[0].value;
        documentacaoRegulacaoSelectedId = documentacaoRegulacaoResult[0].key;
        setDocumentacaoRegulacaoSelected(documentacaoRegulacaoSelected);
        setDocumentacaoRegulacaoSelectedId(documentacaoRegulacaoSelectedId);
    }

    const handleDateDataUltimoDocRegulacaoChange = (date) => {
        setDataUltimoDocRegulacao(date);
    }

    var [documentacaoLiquidacaoSelected, setDocumentacaoLiquidacaoSelected] = useState(null);
    var [documentacaoLiquidacaoSelectedId, setDocumentacaoLiquidacaoSelectedId] = useState(null);
    var [documentacaoLiquidacaoSelectedSave, setDocumentacaoLiquidacaoSelectedSave] = useState(false);
    const [dataUltimoDocLiquidacao, setDataUltimoDocLiquidacao] = useState(null);
    const getDocumentacaoLiquidacao = (currentValue, value) => {
        if (!value) {
            setDocumentacaoLiquidacaoSelected(null);
            setDocumentacaoLiquidacaoSelectedId(null);
            setDocumentacaoLiquidacaoSelectedSave(false);
            return;
        }

        var documentacaoLiquidacaoResult = statusDocumentacao.filter(function (o) {
            return o.key == value;
        });
        documentacaoLiquidacaoSelected = documentacaoLiquidacaoResult[0].value;
        documentacaoLiquidacaoSelectedId = documentacaoLiquidacaoResult[0].key;
        setDocumentacaoLiquidacaoSelected(documentacaoLiquidacaoSelected);
        setDocumentacaoLiquidacaoSelectedId(documentacaoLiquidacaoSelectedId);
    }

    const handleDateDataUltimoDocLiquidacaoChange = (date) => {
        setDataUltimoDocLiquidacao(date);
    }

    //L----> Salvar
    const acaoAlterarDataUltimoDoc = async () => {
        if (isNullOrEmpty(dataUltimoDocRegulacao) && isNullOrEmpty(dataUltimoDocLiquidacao)) {
            notificacaoAlert("Atenção",
                "Você deve enviar no mínimo um dos campos "
                + "'Data do Último Documento de Regulação' ou 'Data do Último Documento de Liquidação'.",
                "warning", 5000);
            return;
        }

        ConfirmarAcao("Deseja alterar data do último documento?").then((result) => {
            if (result.isConfirmed) {
                postConfiguracaoDocumentos({
                    idProcesso: processo?.idProcesso,
                    dtUltimoDocRegulacao: dataUltimoDocRegulacao,
                    dtUltimoDocLiquidacao: dataUltimoDocLiquidacao
                }).then((response) => {
                    notificacaoAlert("Sucesso", "Informações de documentos alteradas com sucesso.", "success", 2000);
                });
            }
        });
    }
    //#endregion
    //#region L--> Cronometro
    var [cronometroAtivo, setCronometroAtivo] = useState(false);
    var [reabirAtivo, setReabirAtivo] = useState(false);

    const getFormatContadorStatus = (valor) => {
        if (valor === null || valor === undefined || valor === '') {
            return "-";
        }

        if (valor === 0 || valor === "0") {
            return "0";
        }

        return (
            <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '2.5rem',
                height: '2.5rem',
                borderRadius: '50%',
                backgroundColor: '#EE4B21',
                color: '#FFF',
                fontWeight: '900',
                fontSize: '15px',
                margin: '0 auto'
            }}>
                {valor}
            </div>
        );
    };

    //L----> Salvar
    const acaoAlterarCronometroRelogio = async () => {
        const msg = cronometroAtivo ? 'desligar' : 'ligar'
        ConfirmarAcao(`Deseja ${msg} o cronômetro do relógio?`).then((result) => {
            if (result.isConfirmed) {
                postConfiguracaoRelogio({
                    idProcesso: processo?.idProcesso,
                    isLigarDesligar: !cronometroAtivo
                }).then((response) => {
                    setCronometroAtivo(!cronometroAtivo);
                    const msgR = cronometroAtivo ? 'desligado' : 'ligado'
                    notificacaoAlert("Sucesso", `Cronômetro do relógio ${msgR} com sucesso.`, "success", 3000);
                });
            }
        });
    }
    //#endregion
    //#endregion

    //#region VALORES
    var [valorPleiteado, setValorPleiteado] = useState(null);
    var [valorEstimado, setValorEstimado] = useState(null);
    var [valorApurado, setValorApurado] = useState(null);

    const parseValor = (val) => {
        if (val === "" || val === null || val === undefined) return null; // Envia null pro banco
        return parseFloat(val); // Envia o número (incluindo 0)
    };

    const acaoAlterarValores = async () => {
        if (isNullOrEmpty(valorPleiteado) && isNullOrEmpty(valorEstimado) && (isNullOrEmpty(valorApurado) && (valorPleiteado <= 0 || valorEstimado <= 0 || valorApurado <= 0))) {
            notificacaoAlert("Atenção",
                "Você deve enviar no mínimo um dos campos 'Valor Pleiteado', 'Valor Estimado' ou 'Valor Apurado'.",
                "warning", 5000);
            return;
        }

        //L----> Salvar
        ConfirmarAcao("Deseja alterar valores do Processo?").then((result) => {
            if (result.isConfirmed) {
                postConfiguracaoValores({
                    idProcesso: processo?.idProcesso,
                    idTipoServico: processo?.idTipoServico,
                    pleiteado: parseValor(valorPleiteado),
                    estimado: parseValor(valorEstimado),
                    apurado: parseValor(valorApurado)
                }).then((response) => {
                    notificacaoAlert("Sucesso", "Valores alterados com sucesso.", "success", 2000);
                });
            }
        });
    }

    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === "") return "";
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    // 2. Processa o que o usuário digita e salva no estado (Número ou Null)
    const handleCurrencyChange = (e, setter) => {
        let value = e.target.value;
        
        // Remove tudo que não for número
        value = value.replace(/\D/g, "");

        // Se estiver vazio, seta NULL
        if (value === "") {
            setter(null);
            return;
        }

        // Converte para Decimal (divide por 100 para ter centavos)
        const numberValue = parseFloat(value) / 100;
        setter(numberValue);
    };
    //#endregion

    //#region Vincular Regulação
    var [vincularRegulacao, setVincularRegulacao] = useState(null);
    var [idVincularRegulacao, setIdVincularRegulacao] = useState(null);
    const [itemRegulacaoSelecionado, setItemRegulacaoSelecionado] = useState(null);
    const [itemsRegulacaoAutocomplete, setItemsRegulacaoAutocomplete] = useState([]);
    const handleOnSearchRegulacao = async (string, results) => {
        if (!string || string.length === 0) {
            setItemsRegulacaoAutocomplete([]);
            return;
        }

        try {
            const response = await api.get(`/Visibilidade/configuracao/list/processos-regulacao?search=${string}`);

            // O componente exige um array com propriedade 'name' para exibir na lista
            // Vamos mapear seus dados para esse formato
            const dadosFormatados = (response.data?.data?.itens || response.data || []).map(item => ({
                ...item,
                // O 'name' é o que aparece na lista suspensa
                name: `${item.processoSigla} - ${item.cliente} (${item.segurado})`
            }));

            setItemsRegulacaoAutocomplete(dadosFormatados);
        } catch (error) {
            console.error("Erro na busca", error);
            setItemsRegulacaoAutocomplete([]);
        }
    };

    const handleOnSelectRegulacao = (item) => {
        setItemRegulacaoSelecionado(item);
        acaoVincularRegulacao();
    };

    const handleOnClearRegulacao = () => {
        setItemRegulacaoSelecionado(null);
        acaoVincularRegulacao();
    };
    //#endregion

    //#region Acionar Perícia
    var [periciaAdd, setPericiaAdd] = useState(null);
    const [periciaAddType, setPericiaAddType] = useState([]);
    const getPericiaAdd = (currentValue, value) => {
        if (!value) {
            setPericiaAdd(null);
            return;
        }

        var periciaAddResult = periciaAddType.filter(function (o) {
            return o.key == value;
        });
        periciaAdd = periciaAddResult[0].value;
        setPericiaAdd(periciaAdd);
        acaoAcionarPericia();
    };
    //#endregion
    
    //#region Líder e Sub-líder
    //#region L--> Líder    
    var [liderSelected, setLiderSelected] = useState(null);
    var [liderSelectedId, setLiderSelectedId] = useState(null);
    const getLider = (currentValue, value) => {
        if (!value) {
            setLiderSelected(null);
            setLiderSelectedId(null);
            return;
        }

        var liderResult = peritosList.filter(function (o) {
            return o.idUsuario == value;
        });
        liderSelected = liderResult[0].nome;
        liderSelectedId = liderResult[0].idUsuario;

        setLiderSelected(liderSelected);
        setLiderSelectedId(liderSelectedId);
    }

    const acaoAlterarLider = async () => {
        ConfirmarAcao("Deseja alterar o líder?").then((result) => {
            if (result.isConfirmed) {
                postConfiguracaoAlterarLider({
                    idProcesso: processo?.idProcesso,
                    idTipoServico: processo?.idTipoServico,
                    idLider: liderSelectedId
                }).then((response) => {
                    notificacaoAlert("Sucesso", "Líder alterado com sucesso.", "success", 2000);
                });
            }
        });
    }
    //#endregion
    //#endregion

    //#region Reabrir/Encerrar Ocorrência
    const [motivoSelected, setMotivoSelected] = useState(null);
    const [motivoSelectedId, setMotivoSelectedId] = useState(null);
    var [EncerrarReabrirSave, setEncerrarReabrirSave] = useState(false);
    var [statusOcorrenciaDescricao, setStatusOcorrenciaDescricao] = useState(null);
    const caracteresDigitados = (statusOcorrenciaDescricao || '').length;

    const motivosObj = isVisualizarAcoesConfiguracao?.statusOcorrencia?.motivos || {};
    const motivosArray = Object.entries(motivosObj)
        .map(([id, nome]) => ({ idUsuario: id, nome: String(nome) }))
        .sort((a, b) => a.nome.localeCompare(b.nome));

    const getMotivo = (currentValue, value) => {
        
        if (!value) {
            setMotivoSelected(null);
            setMotivoSelectedId(null);
            return;
        }

        const achado = motivosArray.find(m => m.idUsuario == value);
        if (achado) {
            setMotivoSelected(achado.nome);
            setMotivoSelectedId(achado.idUsuario);
        }

        console.log("Motivo selecionado ID:", motivoSelectedId);
    };

    const acaoReabrirEncerrarOcorrencia = async () => {

        if (isNullOrEmpty(motivoSelected)) {
            notificacaoAlert("Atenção", "O campo 'Motivo da Ocorrência' é obrigatório.", "warning", 5000);
            return;
        }
        const tipoServicoAtivo = isVisualizarAcoesConfiguracao?.statusOcorrencia?.tipoServico;
        const statusOcorrenciaAtivo = isVisualizarAcoesConfiguracao?.statusOcorrencia?.statusPericiaRegulacao ? "Encerrar" : "Reabrir";
        ConfirmarAcao(`Deseja ${statusOcorrenciaAtivo} o processo?`).then((result) => {
            if (result.isConfirmed) {
                postConfiguracaoAlterarStatusOcorrencia({
                    idProcesso: processo?.idProcesso,
                    idTipoServico: processo?.idTipoServico,
                    idTipoMotivo: parseInt(motivoSelectedId),
                    tipoAcaoProcesso: isVisualizarAcoesConfiguracao?.statusOcorrencia?.statusPericiaRegulacao ? 2 : 3,
                    mensagem: statusOcorrenciaDescricao
                }).then((response) => {
                    setEncerrarReabrirSave(true);
                    getVisibilidadeConfiguracaoAPI();
                    notificacaoAlert("Sucesso", `${statusOcorrenciaAtivo} ${tipoServicoAtivo} realizado com sucesso.`, "success", 2000);
                });


            }
        });
    }
    //#endregion

    //#region USEEFFECTS
    useEffect(() => {
        if (isOpen) {
            setisLoading(true);

            const asyncFn = async () => {
                const delayPromise = new Promise(resolve => setTimeout(resolve, 1000));
                const apiPromise = getVisibilidadeConfiguracaoAPI();
                await Promise.all([delayPromise, apiPromise]);
                setisLoading(false);
            }

            asyncFn();
        };

    }, [isOpen]);
    //#endregion
    //#endregion
    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Cancelar"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <StyledVisibilidadeModal>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="pull-left">
                                    <p className="modal-title">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="24" height="24" className="me-2">
                                            <path fill={'#999'} d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-277.5c0-17-6.7-33.3-18.7-45.3L258.7 18.7C246.7 6.7 230.5 0 213.5 0L64 0zM325.5 176L232 176c-13.3 0-24-10.7-24-24L208 58.5 325.5 176z" /></svg>
                                        Configuração</p>
                                </div>
                                <div className="pull-right">
                                    <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    {isLoading ?
                        (
                            <div className="text-center">
                                <div className="text-items-center">
                                    <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                    <div className="mt-2">
                                        <strong style={{ color: "#EE4B21" }}>Aguarde enquanto validamos as informações</strong>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="mb-3">
                                    <div className="row mb-2" style={{ fontSize: "14px" }}>
                                        <div className="col-2 text-center"><span style={{ color: "#999" }}>Processo</span><br />{processo?.processoSigla || "-"}</div>
                                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Líder</span><br />{processo?.liderProcesso || "-"}</div>
                                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Cliente</span><br />{processo?.cliente || "-"}</div>
                                        <div className="col-4 text-center"><span style={{ color: "#999" }}>Segurado</span><br />{processo?.segurado || "-"}</div>
                                    </div>
                                    <div className="row" style={{ fontSize: "14px" }}>
                                        <div className="col-2 text-center"><span style={{ color: "#999" }}>Disciplina</span><br />{processo?.disciplina}</div>
                                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Abertura</span><br />{new Date(processo?.dataAbertura).toLocaleDateString('pt-BR')}</div>
                                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Status</span><br />{processo?.statusProcesso}</div>
                                    </div>
                                </div>
                                <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                                { isVisualizarAcoesConfiguracao.processoSinistro?.exibir && (
                                    <div className="my-3">
                                        <div className="title-card mb-3"><strong>Processo Sinistro</strong></div>
                                        
                                        <div className="row">
                                            { isVisualizarAcoesConfiguracao?.processoSinistro?.cobertura?.exibir && (
                                                <div className="col-3">
                                                    <div className="card card-sub px-2 mx-0">
                                                        <div className="title-card my-2">Cobertura</div>
                                                        <div className="row my-2">
                                                            <div className={ isVisualizarAcoesConfiguracao?.processoSinistro?.cobertura?.statusCobertura != 2 || coberturaSelectedSave ? 'col-12 my-2 desativado' : 'col-12 my-2' }>
                                                                <div>Status Cobertura</div>
                                                                <DynamicSelect
                                                                    key={"select-status-cobertura"} 
                                                                    placeholder={''}
                                                                    valuetext={coberturaSelected} 
                                                                    label={coberturaSelected}
                                                                    name={`idTipoCobertura`}
                                                                    options={coberturaStatusType}
                                                                    keyValue={'key'} 
                                                                    keyLabel={'value'}
                                                                    clearOption={true}
                                                                    paramMethod={getCoberturas}
                                                                    disabled={ isVisualizarAcoesConfiguracao?.processoSinistro?.cobertura?.statusCobertura != 2 || coberturaSelectedSave }
                                                                />
                                                            </div>

                                                            <div className={ isVisualizarAcoesConfiguracao?.processoSinistro?.cobertura?.statusCobertura != 2 || coberturaSelectedSave ? 'col-12 my-2 desativado' : 'col-12 my-2' }>
                                                                <div>
                                                                    Dt. Cobertura
                                                                </div>
                                                                <DatePicker 
                                                                    key={"dateCobertura"} 
                                                                    dateFormat="dd/MM/yyyy" 
                                                                    locale="pt-BR" 
                                                                    className="input-form" 
                                                                    defaultValue={dataCobertura} 
                                                                    selected={dataCobertura} 
                                                                    onChange={handleDateDataCoberturaChange} 
                                                                    disabled={ isVisualizarAcoesConfiguracao?.processoSinistro?.cobertura?.statusCobertura != 2 || coberturaSelectedSave } />
                                                            </div>
                                                        </div>
                                                        <div className="row mb-1">
                                                            <div className="col-12">
                                                                { isVisualizarAcoesConfiguracao?.processoSinistro?.cobertura?.statusCobertura === 2 && !coberturaSelectedSave && (
                                                                    <button className={`btn default-button-red btn-block`} type="button" onClick={() => acaoAlterarCobertura()}>
                                                                        Salvar
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            { isVisualizarAcoesConfiguracao?.processoSinistro?.documentos?.exibir && (
                                                <div className="col-3 px-0 mx-0">
                                                    <div className="card card-sub px-2 mx-0">
                                                        <div className="title-card my-2">Documentos</div>
                                                        <div className="row my-2">
                                                            <div className={ isVisualizarAcoesConfiguracao?.processoSinistro?.documentos?.docRegulacaoDesativado || documentacaoRegulacaoSelectedSave ? 'col-12 my-2 desativado' : 'col-12 my-2' }>
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <div>Dt. último doc. Regulação</div>
                                                                    <DatePicker key={"dateUltimoDocRegulacao"} dateFormat="dd/MM/yyyy" locale="pt-BR" className="input-form" defaultValue={dataUltimoDocRegulacao} selected={dataUltimoDocRegulacao} onChange={handleDateDataUltimoDocRegulacaoChange} />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <div>Status último doc. Regulação</div>
                                                                        <DynamicSelect
                                                                            key={"select-status-doc-regulacao"} 
                                                                            placeholder={''}
                                                                            valuetext={documentacaoRegulacaoSelected} 
                                                                            label={documentacaoRegulacaoSelected}
                                                                            name={`idTipoDocRegulacao`}
                                                                            options={statusDocumentacao}
                                                                            keyValue={'key'} 
                                                                            keyLabel={'value'}
                                                                            clearOption={true}
                                                                            paramMethod={getDocumentacaoRegulacao}
                                                                            disabled={ isVisualizarAcoesConfiguracao?.processoSinistro?.documentos?.docRegulacaoDesativado || documentacaoRegulacaoSelectedSave }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className={ isVisualizarAcoesConfiguracao?.processoSinistro?.documentos?.docLiquidacaoDesativado || documentacaoLiquidacaoSelectedSave ? 'col-12 my-2 desativado' : 'col-12 my-2' }>
                                                                <div className="row">
                                                                    <div className="col-6">
                                                                        <div>
                                                                            Dt.último doc Liquidação
                                                                        </div>
                                                                        <DatePicker key={"dateUltimoDocLiquidacao"} dateFormat="dd/MM/yyyy" locale="pt-BR" className="input-form" defaultValue={dataUltimoDocLiquidacao} selected={dataUltimoDocLiquidacao} onChange={handleDateDataUltimoDocLiquidacaoChange} />
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <div>Status último doc. Liquidação</div>
                                                                        <DynamicSelect
                                                                            key={"select-status-doc-liquidacao"} 
                                                                            placeholder={''}
                                                                            valuetext={documentacaoLiquidacaoSelected} 
                                                                            label={documentacaoLiquidacaoSelected}
                                                                            name={`idTipoDocLiquidacao`}
                                                                            options={statusDocumentacao}
                                                                            keyValue={'key'} 
                                                                            keyLabel={'value'}
                                                                            clearOption={true}
                                                                            paramMethod={getDocumentacaoLiquidacao}
                                                                            disabled={ isVisualizarAcoesConfiguracao?.processoSinistro?.documentos?.docLiquidacaoDesativado || documentacaoLiquidacaoSelectedSave }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div className="row mb-1 justify-content-end">
                                                            <div className="col-6 text-center">
                                                                <button className={`btn default-button-red btn-block `} type="button" onClick={() => acaoAlterarDataUltimoDoc()}>
                                                                    Salvar
                                                                </button>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            )}

                                            { isVisualizarAcoesConfiguracao?.processoSinistro?.cronometro?.exibir && (
                                                <div className="col-6">
                                                    <div className="card card-sub">
                                                        <div className="title-card my-2">Cronometro</div>
                                                        {
                                                            isVisualizarAcoesConfiguracao.processoSinistro?.cronometro?.statusRelogio && (
                                                                <div className="row mb-1 justify-content-center">
                                                                    <div className="col-8 text-center">
                                                                        <button className={`btn mx-1 mt-2 btn-block  ${cronometroAtivo ? 'btn-primary' : 'btn-secondary border-bottom'}`} type="button" onClick={() => acaoAlterarCronometroRelogio()}>
                                                                            {cronometroAtivo ? 'Desligar Relógio' : 'Ligar Relógio'}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                        <div className="row mb-0 justify-content-around">
                                                            { isVisualizarAcoesConfiguracao.processoSinistro?.cronometro?.regulacao?.exibir && (
                                                            <div className="col-5">
                                                                <div className="my-2 text-center">
                                                                    <div className="title-card-sub">
                                                                        Regulação
                                                                    </div>
                                                                    <div className="mb-2 card-sub-status">
                                                                        { isVisualizarAcoesConfiguracao.processoSinistro?.cronometro?.regulacao?.status }
                                                                    </div>
                                                                    <div className="mb-2 card-sub-status">
                                                                        { isVisualizarAcoesConfiguracao.processoSinistro?.cronometro?.regulacao?.posicao }
                                                                    </div>
                                                                    <div >
                                                                        { isVisualizarAcoesConfiguracao.processoSinistro?.cronometro?.regulacao?.contadorGeral }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            )}
                                                            { isVisualizarAcoesConfiguracao.processoSinistro?.cronometro?.liquidacao?.exibir && (
                                                            <div className="col-5">
                                                                <div className="my-2 text-center">
                                                                    <div className="title-card-sub">
                                                                        Liquidação
                                                                    </div>
                                                                    <div className="mb-2 card-sub-status">
                                                                        { isVisualizarAcoesConfiguracao.processoSinistro?.cronometro?.liquidacao?.status }
                                                                    </div>
                                                                    <div className="mb-2 card-sub-status">
                                                                        { isVisualizarAcoesConfiguracao.processoSinistro?.cronometro?.liquidacao?.posicao }
                                                                    </div>
                                                                    <div >
                                                                        { isVisualizarAcoesConfiguracao.processoSinistro?.cronometro?.liquidacao?.contadorGeral }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>
                                    </div>
                                )}

                                { isVisualizarAcoesConfiguracao.valores?.exibir && (
                                    <div className="my-3">
                                        <div className=" title-card "><strong>Valores</strong></div>
                                        <div className="row my-2 justify-content-between" style={{ fontSize: "14px" }}>
                                            <div className="col-3 text-center">
                                                <StldInput>
                                                    <label className="focused">Pleiteado</label>
                                                    <input
                                                        type="text"
                                                        className="input-form"
                                                        style={{ textAlign: 'right' }}
                                                        placeholder="R$ 0,00"
                                                        value={formatCurrency(valorPleiteado)} 
                                                        onChange={(e) => handleCurrencyChange(e, setValorPleiteado)}
                                                        disabled={ !isVisualizarAcoesConfiguracao.statusOcorrencia?.statusPericiaRegulacao }
                                                    />
                                                </StldInput>
                                            </div>
                                            <div className="col-3 text-center">
                                                <StldInput>
                                                    <label className="focused">Estimado</label>
                                                    <input
                                                        type="text"
                                                        className="input-form"
                                                        style={{ textAlign: 'right' }}
                                                        placeholder="R$ 0,00"
                                                        value={formatCurrency(valorEstimado)}
                                                        onChange={(e) => handleCurrencyChange(e, setValorEstimado)}
                                                        disabled={ !isVisualizarAcoesConfiguracao.statusOcorrencia?.statusPericiaRegulacao }
                                                    />
                                                </StldInput>
                                            </div>
                                            <div className="col-3 text-center">
                                                <StldInput>
                                                    <label className="focused">Apurado</label>
                                                    <input
                                                        type="text"
                                                        className="input-form"
                                                        style={{ textAlign: 'right' }}
                                                        placeholder="R$ 0,00"
                                                        value={formatCurrency(valorApurado)}
                                                        onChange={(e) => handleCurrencyChange(e, setValorApurado)}
                                                        disabled={ !isVisualizarAcoesConfiguracao.statusOcorrencia?.statusPericiaRegulacao }
                                                    />
                                                </StldInput>
                                            </div>
                                            <div className="col-3 text-center">
                                                <button className={`btn default-button-red btn-block py-2`} type="button" disabled={ !isVisualizarAcoesConfiguracao.statusOcorrencia?.statusPericiaRegulacao } onClick={() => acaoAlterarValores()}>
                                                    Salvar
                                                </button>
                                            </div>
                                        </div>

                                        <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>
                                    </div>
                                )}

                                <div className="row my-3">
                                    { isVisualizarAcoesConfiguracao.acionarPericia?.exibir && (
                                    <div className="col-6 my-2">
                                        <div className="">
                                            <div className="title-card">
                                                <strong>Acionar Pericia</strong>
                                            </div>
                                            <div >
                                                <Select
                                                    className="basic-single"
                                                    placeholder={'Pericia'}
                                                    key={'periciaAdd3' + periciaAdd?.id}
                                                    defaultValue={[periciaAdd]}
                                                    options={periciaAddType}
                                                    onChange={getPericiaAdd}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    )}

                                    { isVisualizarAcoesConfiguracao.vincularRegulacao?.exibir && (
                                        <div className="col-6 my-2">
                                            <div className="">
                                                <div className="title-card">
                                                    <strong>Vincular Regulação</strong>
                                                </div>
                                                <div >
                                                    <ReactSearchAutocomplete
                                                        key={"visibilidade-autocomplete-regulacao"}
                                                        items={itemsRegulacaoAutocomplete}
                                                        onSearch={handleOnSearchRegulacao}
                                                        onSelect={handleOnSelectRegulacao}
                                                        onClear={handleOnClearRegulacao}
                                                        autoFocus
                                                        placeholder="Digite Sigla, Cliente ou Segurado..."
                                                        styling={searchStyling}
                                                        fuseOptions={{ keys: ["name"], threshold: 1, minMatchCharLength: 0 }}
                                                        resultStringKeyName="name"

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    
                                    <div className="col-5 pe-5 my-2" >
                                        <div className="">
                                            <div className="title-card">
                                                <strong>Líder</strong>
                                            </div>
                                            <div className={ isVisualizarAcoesConfiguracao.alterarLider?.desativado ? 'desativado' : '' }>
                                                <DynamicSelect
                                                    key={"select-lider"} 
                                                    placeholder={''}
                                                    valuetext={liderSelected} 
                                                    label={liderSelected}
                                                    name={`idLider`}
                                                    options={[...peritosList].sort((a, b) => a.nome.localeCompare(b.nome))}
                                                    keyValue={'idUsuario'} 
                                                    keyLabel={'nome'}
                                                    clearOption={true}
                                                    paramMethod={getLider}
                                                    classNameCustom={'py-2'}
                                                    disabled={isVisualizarAcoesConfiguracao.alterarLider?.desativado}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="col-1 ps-5 my-2">
                                        <div className="">
                                            <div className="title-card">
                                                &nbsp;
                                            </div>
                                            <div >
                                                <button className={`btn default-button-red pull-right mt-2`} disabled={ isVisualizarAcoesConfiguracao.alterarLider?.desativado } type="button" onClick={() => acaoAlterarLider()}>
                                                    Salvar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    { isVisualizarAcoesConfiguracao.alterarSubLider && (
                                        <div className="col-6 mb-2">
                                            <div className="">
                                                <div className="title-card">
                                                    <strong>Sub Líder</strong>
                                                </div>
                                                <div className="row ">
                                                    <div className="col-2">
                                                        <div className="mt-2">
                                                            <ToggleSwitchFilters key={"toggleIsSubLider"} config={toggleSubLiderConfig} setStatus={(status) => getToggleSubLiderCheck(status)} />
                                                        </div>
                                                    </div>

                                                    <div className="col-10 ">
                                                        <Select
                                                            className="basic-single"
                                                            placeholder={'Sub Líder'}
                                                            key={'subLider2' + subLider?.id}
                                                            defaultValue={[subLider]}
                                                            options={peritosType}
                                                            onChange={getSubLider}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 
                                    )}
                                </div>

                                { isVisualizarAcoesConfiguracao.statusOcorrencia?.exibir && (
                                <div className="row mb-2">
                                    <div className="col-12">
                                        <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>
                                        <div className="">
                                            <div className="title-card"><strong>Status Ocorrência</strong></div>
                                            <div className="row justify-content-center my-2">
                                                <div className="">
                                                    <div className="">
                                                        <div className="row justify-content-between mt-2">
                                                            <div className="row justify-content-between">
                                                                <div className="col-10">
                                                                    <div className="title-card">
                                                                        Motivo { isVisualizarAcoesConfiguracao.statusOcorrencia?.statusPericiaRegulacao ? 'Encerramento' : 'Reabertura'}
                                                                    </div>
                                                                    <div>
                                                                        <DynamicSelect
                                                                            key={"select-motivo-ocorrencia"}
                                                                            placeholder={''}
                                                                            valuetext={motivoSelected}
                                                                            label={motivoSelected}
                                                                            name={`idMotivo`}
                                                                            options={motivosArray}
                                                                            keyValue={'idUsuario'}
                                                                            keyLabel={'nome'}
                                                                            clearOption={true}
                                                                            paramMethod={getMotivo}
                                                                            classNameCustom={'py-2'}
                                                                            disabled={ EncerrarReabrirSave }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-between mt-1">
                                                                <div className="col-10 text-center">
                                                                    <div>
                                                                        <textarea 
                                                                            rows="2" 
                                                                            className="input-form" 
                                                                            value={statusOcorrenciaDescricao} // Use 'value' em vez de 'defaultValue' para o React controlar o texto corretamente
                                                                            placeholder="Descrição" 
                                                                            name="descricao" 
                                                                            onChange={(e) => setStatusOcorrenciaDescricao(e.target.value)} // Pegando apenas o texto digitado
                                                                            maxLength={200} 
                                                                            disabled={ EncerrarReabrirSave }
                                                                        />
                                                                        
                                                                        {/* 2. O contador visual logo abaixo do textarea */}
                                                                        <div className="text-end text-muted" style={{ fontSize: '0.85rem', marginTop: '4px' }}>
                                                                            {caracteresDigitados}/200
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-2 text-center">
                                                                    <button className={`btn mx-1 mt-2 btn-block ${ isVisualizarAcoesConfiguracao.statusOcorrencia?.statusPericiaRegulacao ? 'btn-encerrar' : 'btn-reabrir'}`} type="button" onClick={() => acaoReabrirEncerrarOcorrencia()} disabled={ EncerrarReabrirSave }>
                                                                        { isVisualizarAcoesConfiguracao.statusOcorrencia?.statusPericiaRegulacao ? 'Encerrar' : 'Reabrir'}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>
                                            
                                            <div className="row justify-content-center my-2">
                                                {isVisualizarAcoesConfiguracao.statusOcorrencia?.listaDeOcorrencias && isVisualizarAcoesConfiguracao.statusOcorrencia?.listaDeOcorrencias?.length > 0 ? (
                                                    <div className="col-12">
                                                        <div className="table-responsive">
                                                            <div style={{ maxHeight: '320px', overflowY: 'auto' }}>
                                                                <table className="table table-sm mb-0 ">
                                                                    <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 5, background: '#fff' }}>
                                                                        <tr>
                                                                            <th colSpan={7} className="text-start"> Ocorrências</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th scope="col" className="text-center">Data</th>
                                                                            <th scope="col" className="text-center">Ação</th>
                                                                            <th scope="col" className="text-center">Responsável</th>
                                                                            <th scope="col" className="text-center">Motivo</th>
                                                                            <th scope="col" className="text-center">Descrição</th>

                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {[...(isVisualizarAcoesConfiguracao.statusOcorrencia?.listaDeOcorrencias || [])]
                                                                            .sort((a, b) => new Date(b.dataOperacao) - new Date(a.dataOperacao)) // Ordena do mais recente (b) para o mais antigo (a)
                                                                            .map((tsItem, index) => {
                                                                                // 1. Formata a data para o padrão brasileiro (DD/MM/YYYY)
                                                                                const dataFormatada = tsItem.dataOperacao 
                                                                                    ? new Date(tsItem.dataOperacao).toLocaleDateString('pt-BR') 
                                                                                    : '-';

                                                                                // 2. Busca o nome do motivo lá no objeto principal usando o ID que veio no item
                                                                                const motivosObj = isVisualizarAcoesConfiguracao.statusOcorrencia?.motivos || {};
                                                                                const textoMotivo = motivosObj[tsItem.tipoMotivo] || tsItem.tipoMotivo || '-';

                                                                                return (
                                                                                    <tr key={tsItem.idRegulacaoOcorrenciaStatus || index}>
                                                                                        <td className="text-center">{dataFormatada}</td>
                                                                                        <td className="text-center">{tsItem?.tipoAcaoProcessoDescricao}</td>
                                                                                        <td className="text-center">{tsItem?.nomeUsuario}</td>
                                                                                        <td className="text-center">{tsItem?.tipoMotivoDescricao}</td>
                                                                                        <td className="text-center">{tsItem?.mensagem || '-'}</td>
                                                                                    </tr>
                                                                                );
                                                                        })}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <span></span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )}
                            </>
                        )}
                </StyledVisibilidadeModal>
            </StyledForm>
        </Modal >
    );
};